import { RankingDistributionMetric } from "app/pages/keyword-research/website-analysis/pages/ranking-distribution/rankingDistribution.types";
import {
    TableCellDomainMarker,
    TableCellDomainName,
    TableCellStyle,
} from "app/pages/keyword-research/website-analysis/pages/ranking-distribution/RankingDistributionChartTooltip";

export const TOOLTIP_COLUMN_FIELD = {
    [RankingDistributionMetric.ByPosition]: "domain",
    [RankingDistributionMetric.ByWebsite]: "position",
};

const TOOLTIP_METRIC_CONFIGS = {
    [RankingDistributionMetric.ByPosition]: (domain: string) => ({
        field: TOOLTIP_COLUMN_FIELD[RankingDistributionMetric.ByPosition],
        displayName: domain,
    }),
    [RankingDistributionMetric.ByWebsite]: (positions: string) => ({
        field: TOOLTIP_COLUMN_FIELD[RankingDistributionMetric.ByWebsite],
        displayName: positions,
    }),
};

export const TOOLTIP_METRIC = {
    [RankingDistributionMetric.ByPosition]: (translatedWords: Record<string, string>) => ({
        ...TOOLTIP_METRIC_CONFIGS[RankingDistributionMetric.ByPosition](translatedWords.domain),
        cellComponent: ({ value: { name, color } }) => {
            return (
                <TableCellStyle>
                    <TableCellDomainMarker background={color} />
                    <TableCellDomainName>{name}</TableCellDomainName>
                </TableCellStyle>
            );
        },
    }),
    [RankingDistributionMetric.ByWebsite]: (translatedWords: Record<string, string>) => ({
        ...TOOLTIP_METRIC_CONFIGS[RankingDistributionMetric.ByWebsite](translatedWords.positions),
        cellComponent: ({ value: { name, color } }) => {
            return (
                <TableCellStyle>
                    <TableCellDomainMarker background={color} />
                    <TableCellDomainName>{name}</TableCellDomainName>
                </TableCellStyle>
            );
        },
    }),
};
